module.exports = __webpack_public_path__ + "img/page-1_img13.30e6f275.jpg";